module.exports = __webpack_public_path__ + "static/media/title.4ca3fc4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/activity22/title.png
// module id = 338
// module chunks = 0